import React, { Component, Fragment } from 'react';
import axios from 'axios';
import './chat.css';
import SignalRController from '../SignalRController.js';
import { ChatCard } from './ChatCard';
import ChatContext from './../context/ChatContext';
import { NotificationManager } from 'react-notifications';
import { Modal } from 'react-bootstrap';
import Moment from 'react-moment';


export class PresenterChat extends Component {
    constructor(props) {
        super(props)
        this.state = {
            chatUpdate: this.props.email,
            responseChats: [],
            errors: {},
            presenterInboxItems: [],
            refreshPresenterInbox: false,
            showModal: false,
            modalContent: null
            //ChatsUpdate: this.props.chatupdate
        };
        this.answeredMessage = this.answeredMessage.bind(this);
        this.ignoreMessage = this.ignoreMessage.bind(this);
        this.GetChatPresenterItems = this.GetChatPresenterItems.bind(this);
        this.refreshChat = this.refreshChat.bind(this);
        this.removeChatFromInbox = this.removeChatFromInbox.bind(this);
    }

    async componentDidMount() {

        this.GetChatPresenterItems();
        SignalRController.addCallbackAdm2Adm_MessageUpdate(this.GetChatPresenterItems);
    }

    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    async GetChatPresenterItems() {
        await this.context.getChats();
        if (this.context.chats == null) return null;

        let messages = this.context.chats.messages;
        let inboxes = this.context.chats.inboxes;

        var thisinbox = inboxes.filter((chat) => chat.inboxType === 4).sort((a, b) => a.sortOrder > b.sortOrder ? 1 : -1); // 4==presenterinbox
        var items = thisinbox.map((inboxItem) => (messages.find(chats => chats.messageId === inboxItem.messageId)));

        this.setState({ presenterInboxItems: items });
        return items;
    }


    // This is the Presenter Ignore option - remove it from the Presenter Inbox and put it back in the Admin Inbox
    async ignoreMessage(e, chat) {
        e.stopPropagation();
        try {
            let VmeetingId = parseInt(sessionStorage.getItem('VMId'));
            // Add chat back into Moderator Admin Inbox
            await axios.get(`api/AddChatToInbox`, { params: { vmId: VmeetingId, chatId: chat.messageId, inbox: 1 } }).then(res => {
            })

            // Remove Chat from Presenter Inbox (4)
            await axios.get(`api/RemoveChatFromInbox`, { params: { VmId: VmeetingId, chatId: chat.messageId, attendeeId: chat.attendeeId, inbox: 4, oneOrMany: 0 } }).then(res => {
            })

            await axios.get('api/UpdateMessageFlags', { params: { VmId: VmeetingId, chatId: chat.messageId, attendeeId: chat.attendeeId, passedBack: 1, answered: chat.answered } }).then(res => {
            })

            this.refreshChat();
        }
        catch (error) {
            NotificationManager.error("Sorry, there was a problem sending the message back to the moderator", "PresenterChat Component " + error.message, 4000);
        }
    }

    async refreshChat() {
        await this.context.getChats();
        let chatData = this.context.chats;
        this.setState({ chats: chatData, Loading: false });
    }

    // This is the Presenter Answered Message option - Flag it send a message back to the user
    async answeredMessage(e, chat) {
        e.stopPropagation();

        try {
            let VmeetingId = parseInt(sessionStorage.getItem('VMId'));

            let origMsg = chat.messageText.length > 100 ? chat.messageText.substring(0, 100) + '...' : chat.messageText;
            var chatResponse = {
                AdminId: 1, // not used
                VMeetingId: VmeetingId,
                QuestionText: "Automated Message: This question '" + origMsg + "' has been answered in the meeting.",
                SubmittedById: chat.attendeeId,
                SubmittedByName: 'notused',
                messageDirection: 99  // Not Used
            };

            await axios.get('api/UpdateMessageFlags', { params: { VmId: VmeetingId, chatId: chat.messageId, attendeeId: chat.attendeeId, passedBack: chat.passedBack, answered: 1 } }).then(res => {
            })

            await axios.post(`api/SubmitAdminMessage`, chatResponse).then(res => {
            })

            this.refreshChat();
        }
        catch (error) {
            NotificationManager.error("Sorry, there was a problem confirming you answered this message", "PresenterChat Component " + error.message, 4000);
        }
    }

    async removeChatFromInbox(chat, inbox) {
        try {
            let VmeetingId = parseInt(sessionStorage.getItem('VMId'));
            axios.get(`api/RemoveChatFromInbox`, { params: { VmId: VmeetingId, chatId: chat.messageId, attendeeId: chat.attendeeId, inbox: inbox, oneOrMany: 1 } }).then(res => {
            })
            this.refreshChat();
        }
        catch (error) {
            NotificationManager.error("Sorry, there was a problem removing this message", "PresenterChat Component " + error.message, 4000);
        }
    }

    modalTrigger = (chat, inbox, type) =>{
        this.setState({ showModal: true, modalContent: chat })
    }

    modalClose = () => {
        this.setState({ showModal: false, modalContent: null })
    }

    render() {
        if (this.context.loading === false) {
            var presenterInboxItems = this.state.presenterInboxItems;

            return (
                <Fragment>
                    <div className="h-100">
                        <div className="chat-heading">PRESENTERS QUESTIONS</div>
                        <div className="chat-box-pres">
                            {
                                !this.state.Loading ?
                                    (presenterInboxItems && presenterInboxItems.length > 0) ?
                                        <div className="chat-left-inbox">
                                            <ChatCard
                                                chatItems={presenterInboxItems}
                                                respond={this.modalTrigger}
                                                inbox={4}
                                                presenter={true}
                                                ignore={this.ignoreMessage}
                                                answered={this.answeredMessage}
                                                removeChatFromInbox={this.removeChatFromInbox}
                                                isAuthorized={this.context.isAuthorized('PresInbox', 'Write')}
                                                authFunc={this.context.isAuthorized}
                                            />
                                        </div>
                                        : <Fragment>
                                            <div className="mx-3">
                                                <p> No chats found </p>
                                            </div>
                                        </Fragment>
                                    : <div className="dashHeading">Loading....</div>
                            }
                        </div>
                    </div>
                    <DisplayModal
                        show={this.state.showModal}
                        onHide={this.modalClose}
                        content={this.state.modalContent}
                    />
                    
                </Fragment>
            );
        } else return (<div></div>);
    }
}

PresenterChat.contextType = ChatContext;

export default PresenterChat



function DisplayModal(props) {
    let content = props.content;
    if (content) {
        return (
            <Modal
                {...props}
                dialogClassName="modal-65w"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <div className="d-flex justify-content-between">
                            <div className="inbox4 fw-bold">{content.attendeeName}</div>
                            <div><Moment format="D MMM HH:mm:ss" date={content.messageDateTime} /></div>
                        </div>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="m-1 px-2">
                        <div className="messageText fs-3">{content.messageText }</div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-primary" onClick={props.onHide}>Close</button>
                </Modal.Footer>
            </Modal>
        );
    } else {return null }
}
